
import React from 'react';

const AboutUsPage: React.FC = () => {
  return (
    <div className="w-full max-w-4xl bg-white p-8 rounded-lg shadow-lg animate-fade-in-up">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">About TypeoGO</h1>

      <div className="space-y-6 text-gray-700 leading-relaxed">
        <p>
          <strong>TypeoGO</strong> was founded by a group of educators and developers passionate about making digital literacy accessible and engaging for all students. We believe that typing is a fundamental skill for the 21st century, and our goal is to provide the best possible tools for schools to teach this skill effectively.
        </p>
        
        <div>
          <h2 className="text-2xl font-semibold mb-3 text-blue-600">Our Mission</h2>
          <p>
            Our mission is to empower students with fast and accurate typing skills through a fun, adaptive, and comprehensive learning platform. We strive to turn the often tedious task of learning to type into an exciting journey of progress and achievement.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-3 text-blue-600">Our Vision</h2>
          <p>
            We envision a world where every student has the keyboarding proficiency needed to succeed in their academic and future professional lives. By providing a platform that is effective for students, manageable for teachers, and insightful for parents, we aim to be the leading typing solution for K-12 education worldwide.
          </p>
        </div>

        <p>
          Our platform is designed with students, teachers, and parents in mind, offering a structured curriculum, a variety of exciting games, and powerful administrative tools to track progress and customize learning. We are committed to continuous improvement and working closely with our partner schools to meet their evolving needs.
        </p>
        <p>
          Thank you for being a part of the TypeoGO community.
        </p>
      </div>
    </div>
  );
};

export default AboutUsPage;